module.exports = __webpack_public_path__ + "img/20190713125255YY截图20190712232609.81c62ece.png";